








































































































































































































































































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Emit } from 'vue-property-decorator';
import { equipments } from '@/modules/shared/shared/store/namespaces';
import { EquipmentsActions } from '@/modules/equipments/store/equipments.actions';
import { EquipmentsGetters } from '@/modules/equipments/store/equipments.getters';
import { Parameter } from '@/modules/equipments/domain/parameter';
import { NewEquipment } from '@/modules/equipments/domain/new-equipment';

@Component
export default class EquipmentForm extends Vue {
    @Prop({ required: true })
    buildingsDataCentersList!: {
        id: number;
        name: string;
        buildingsDataCenters: {
            id: number;
            building: {
                id: number;
                name: string;
            };
        }[];
    }[];

    @Prop({ required: true })
    createEquipment!: boolean;

    @Prop({ required: true })
    equipmentToUpdate!: NewEquipment;

    currentStep: number = 1;
    equipmentTransaction: boolean = false;
    equipmentTransactionFinished: boolean = false;
    finishedText: string = '';
    loadingText: string = '';
    rules: {
        defaultRules: any[];
        defaultArrayRules: any[];
    } = {
        defaultRules: [(v: any) => !!v || 'Requerido'],
        defaultArrayRules: [(v: any) => !!v.length || 'Requerido'],
    };
    show: boolean = false;
    snackbar: boolean = false;
    snackbarColor: string = '';
    snackbarText: string = '';
    steps: number = 2;

    $refs!: {
        form: any;
    };

    isFetchingData: boolean = false;

    async mounted() {
        this.equipmentTransaction = false;
        this.equipmentTransactionFinished = false;
        this.isFetchingData = true;
        await this.getParameters();
        this.isFetchingData = false;
    }

    @Emit('closeDialog')
    closeDialog(reload = true) {
        this.$emit('closeDialog', reload);
    }

    get buildingsDataCentersOptions() {
        let buildingsDataCentersOptions: {
            id: number;
            name: string;
        }[] = [];
        this.buildingsDataCentersList.forEach(dataCenter => {
            dataCenter.buildingsDataCenters.forEach(buildingsDataCenter => {
                let buildingsDataCentersOption: {
                    id: number;
                    name: string;
                } = {
                    id: buildingsDataCenter.id,
                    name: `${dataCenter.name}-${buildingsDataCenter.building.name}`,
                };
                buildingsDataCentersOptions.push(buildingsDataCentersOption);
            });
        });
        return buildingsDataCentersOptions;
    }

    get equipment() {
        let newEquipment: NewEquipment = {
            id: -1,
            name: '',
            buildingsDataCentersSelected: [],
            parametersSelected: [],
        };

        if (!this.createEquipment) {
            newEquipment = this.equipmentToUpdate;
        }

        return newEquipment;
    }

    get formIsValid() {
        return this.$refs.form.validate();
    }

    get parameters() {
        let parametersOptions: {
            id: number;
            name: string;
            measureUnit: string;
            fullName: string;
        }[] = [];

        if (this.availableParameters && this.availableParameters.length) {
            this.availableParameters.forEach(parameter => {
                let parametersOption: {
                    id: number;
                    name: string;
                    measureUnit: string;
                    fullName: string;
                } = {
                    id: parameter.id,
                    name: parameter.name,
                    measureUnit: parameter.measureUnit,
                    fullName: `${parameter.name} ${parameter.measureUnit}`,
                };
                parametersOptions.push(parametersOption);
            });
        }
        return parametersOptions;
    }

    get titleForm() {
        if (this.createEquipment) {
            return 'Registrar Equipo';
        } else {
            return 'Modificar Equipo';
        }
    }

    closeSnackbar() {
        this.snackbar = false;
        this.snackbarText = '';
    }

    columnLayout(number: number) {
        if (number === 1) {
            return 12;
        } else {
            if (number === 2) {
                return 6;
            } else {
                return 4;
            }
        }
    }

    async getParameters() {
        const failed = await this.fetchParameters();
        if (failed) {
            failed.showError();
        }
    }

    async nextStep(n: number) {
        if (this.formIsValid) {
            if (n === this.steps) {
                this.currentStep = 1;
            } else {
                this.currentStep = n + 1;
            }
        }
    }

    previousStep(n: number) {
        if (n === 1) {
            this.currentStep = 1;
        } else {
            this.currentStep = n - 1;
        }
    }

    removeBuildingsDataCentersSelected(item) {
        const index = this.equipment.buildingsDataCentersSelected.indexOf(item.id);
        if (index >= 0) {
            this.equipment.buildingsDataCentersSelected.splice(index, 1);
        }
    }

    removeParametersSelected(item) {
        const index = this.equipment.parametersSelected.indexOf(item.id);
        if (index >= 0) {
            this.equipment.parametersSelected.splice(index, 1);
        }
    }

    selectedBuildingsDataCentersToDisplay() {
        let selectedBuildingsDataCenters: {
            id: number;
            name: string;
        }[] = [];

        if (
            this.equipment.buildingsDataCentersSelected &&
            this.equipment.buildingsDataCentersSelected.length
        ) {
            this.equipment.buildingsDataCentersSelected.forEach(buildingsDataCenter => {
                let buildingsDataCenterAux: any = this.buildingsDataCentersOptions.find(
                    buildingsDataCentersOption => {
                        return buildingsDataCentersOption.id === buildingsDataCenter;
                    },
                );
                if (buildingsDataCenterAux) {
                    selectedBuildingsDataCenters.push(buildingsDataCenterAux);
                }
            });
        }
        return selectedBuildingsDataCenters;
    }

    selectedParametersToDisplay() {
        let selectedParameters: {
            id: number;
            name: string;
        }[] = [];

        if (this.equipment.parametersSelected && this.equipment.parametersSelected.length) {
            this.equipment.parametersSelected.forEach(parameterSelected => {
                let parameterAux: any = this.parameters.find(parameter => {
                    return parameter.id === parameterSelected;
                });
                if (parameterAux) {
                    selectedParameters.push(parameterAux);
                }
            });
        }
        return selectedParameters;
    }

    async submitEquipment() {
        if (this.formIsValid) {
            if (this.createEquipment) {
                this.loadingText = 'Registrando el equipo';
                this.finishedText = 'Equipo registrado exitosamente';
                this.equipmentTransaction = true;
                const failed = await this.createAnEquipment(this.equipment);
                this.equipmentTransactionFinished = true;
                if (failed) {
                    failed.showError();
                } else {
                    this.closeDialog();
                }
            } else {
                this.loadingText = 'Modificando equipo';
                this.finishedText = 'Equipo modificado exitosamente';

                this.equipmentTransaction = true;
                const failed = await this.updateAnEquipment(this.equipment);
                this.equipmentTransactionFinished = true;
                if (failed) {
                    failed.showError();
                } else {
                    this.closeDialog();
                }
            }
        }
    }

    @equipments.Action(EquipmentsActions.FETCH_PARAMETERS)
    fetchParameters!: () => Promise<RequestResponse>;

    @equipments.Action(EquipmentsActions.CREATE_EQUIPMENT)
    createAnEquipment!: (equipment: NewEquipment) => Promise<RequestResponse>;

    @equipments.Action(EquipmentsActions.UPDATE_EQUIPMENT)
    updateAnEquipment!: (equipment: NewEquipment) => Promise<RequestResponse>;

    @equipments.Getter(EquipmentsGetters.GET_PARAMETERS)
    availableParameters!: Parameter[];
}
